/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Setup_Guide_TitleInputs */



/**
* | output |
* | --- |
* | "Set up in the provider's console first" |
*
* @param {Integrations_Setup_Guide_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_setup_guide_title = /** @type {((inputs?: Integrations_Setup_Guide_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Setup_Guide_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zuerst in der Konsole des Anbieters einrichten")
	return /** @type {LocalizedString} */ ("Set up in the provider's console first")
});